@if (isDev) {
    <div class="fdo-host" [class.fdo-open]="isOpen()">
        <div class="fdo-panel" [class.fdo-panel--visible]="isOpen()">
            <div class="fdo-header">
                <span class="fdo-title">
                    <mat-icon class="fdo-title-icon">flag</mat-icon>
                    Feature Flags
                    @if (featureFlagService.hasOverrides) {
                        <span class="fdo-override-badge" matTooltip="Overrides active — not reflecting server state">
                            overrides active
                        </span>
                    }
                </span>
                <div class="fdo-header-actions">
                    @if (featureFlagService.hasOverrides) {
                        <button mat-button color="warn" class="fdo-reset-btn" (click)="resetAll()" matTooltip="Reset all overrides to server values">
                            Reset
                        </button>
                    }
                    <button mat-icon-button class="fdo-close-btn" (click)="isOpen.set(false)" matTooltip="Close">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            <div class="fdo-list">
                @if (flags().length === 0) {
                    <div class="fdo-empty">No flags loaded yet</div>
                }
                @for (flag of flags(); track flag.name) {
                    <div class="fdo-row" [class.fdo-row--overridden]="flag.overridden">
                        <span class="fdo-flag-name" [title]="flag.name">{{ flag.name }}</span>
                        @if (flag.overridden) {
                            <mat-icon class="fdo-override-icon" matTooltip="Locally overridden">edit</mat-icon>
                        }
                        <mat-slide-toggle
                            class="fdo-toggle"
                            color="primary"
                            [checked]="flag.value"
                            (change)="toggle(flag)" />
                    </div>
                }
            </div>
        </div>
        <button
            mat-mini-fab
            class="fdo-fab"
            color="primary"
            (click)="isOpen.set(!isOpen())"
            [matTooltip]="isOpen() ? '' : 'Feature Flags (dev only)'">
            <mat-icon>flag</mat-icon>
            @if (featureFlagService.hasOverrides) {
                <span class="fdo-fab-badge">!</span>
            }
        </button>
    </div>
}
